module.exports = __webpack_public_path__ + "components/templates/images/icons/add.svg";